import { createApp } from "vue";
import App from "./App.vue";
import VueLazyLoad from "vue3-lazyload";
import i18n from "./i18n";
import router from "./router";

const app = createApp(App).use(i18n).use(router);

app.use(VueLazyLoad, {});

app.mount("#app");
